
import { useState } from 'react';
import { useEffect } from 'react';
import { Fragment } from 'react';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {Card} from 'reactstrap';
import {CardBody} from 'reactstrap';
import { BackToList } from '../../../../Constant'; 
import { AccessName } from '../../../../Constant'; 
import GenerateForm from '../../../Common/Component/GenerateForm'; 
import { base_form_fields } from '../../../../Data/FormField/PublicData'; 
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate'; 
import CustomizerContext from '../../../../_helper/Customizer'; 
import { Breadcrumbs } from '../../../../AbstractElements'; 
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { AccessNamesApi } from '../../../../api';
import useAuth from '../../../../Hooks/useAuth';

function AccessNamesCreate() {
    const history = useNavigate();
    const axiosPrivate = useAxiosPrivate()
    const { userOrganisationId } = useAuth();
    const { layoutURL } = useContext(CustomizerContext);
    const [formFields, setFormFields] = useState(base_form_fields(`${AccessName}`));
    const lists = `${process.env.PUBLIC_URL}/technical/access-names/${layoutURL}`;
    
    const { formState: { errors },} = useForm();

    const addNewRecord =  async (newRecord) => {
        if (newRecord === '') { 
            errors.showMessages();
        }

        const newRecordTemp = {
            organisation_id: userOrganisationId,
            name: newRecord.name,
            description: newRecord.name,
            is_active: newRecord.is_active,
            //file: newRecord.file[0]
        };

        try {
            await axiosPrivate.post(AccessNamesApi, newRecordTemp, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then((resp) => {
                toast.success(`${resp.data.name} is successfully added.`)
                history(lists);
            });
        } catch (error) {
            if (error.response && error.response.status === 422) {
                toast.error('Validation Errors');
            } else if (error.response && error.response.status === 400) {
                toast.error(error.response.data.detail);
            }
            else {
                toast.error('Form submission error');
            }
            throw error;
        }  
    };

    return (

        <>

            <Fragment>
                <Breadcrumbs parent="Technical" title="Access Names" mainTitle="Access Names" />
                <Card className='ribbon-wrapper-right b-l-secondary border-2'>
                    <CardBody>
                        <Link to={lists}>
                            <div className="ribbon ribbon-clip-right ribbon-right ribbon-primary">
                                {BackToList}
                            </div>
                        </Link>

                        <GenerateForm formFields={formFields} onSubmit={addNewRecord} listUrl={lists} formTitle={"Access Names"} onEdit={undefined} editRecord={undefined} />

                    </CardBody>
                </Card>
            </Fragment>


        </>

    )
}

export default AccessNamesCreate